import React from 'react';
import ReviewDetailSection from '../../../sections/AdminDashboard/ReviewManagement/ReviewDetail';

const ReviewDetail = () => {
  return <ReviewDetailSection />;
};

export default ReviewDetail;


